import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { $t } from "~/i18n.js";

export const EditButton = (args) => {
  return (
    <Button size="small" {...args} icon={<EditOutlined />}>
      {args.title || $t("Wijzig")}
    </Button>
  );
};
